import { inject, OnDestroy, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { BlockUIService } from '../shared/services/blockUI.service';
import { StorageService } from '../shared/services/storage.service';
import { CompanyDTO, User, UserDTO } from 'src/app/interfaces/base-entity';
import { UserRoleEnum, StorageKeys } from 'src/app/enums/enums';
import { SgsstAuthUserService } from '../shared/services/auth.service';
import { Subscriber, Subscription } from 'rxjs';
import { UserRoleService } from 'src/app/utils/user-role.service';
import { MenuConfig } from './config/menu.config';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {
    user: UserDTO | null = null;
    model: any[] = [];
    currentCompany: CompanyDTO | null = null;
    public blockUI: BlockUIService = inject(BlockUIService);
    public userRoleService: UserRoleService = inject(UserRoleService);
    suscribers = new Subscription();
    constructor(public layoutService: LayoutService,
        private storage: StorageService,
        public authSsgtService: SgsstAuthUserService
    ) { }
    ngOnDestroy(): void {
        this.suscribers?.unsubscribe();
    }

    ngOnInit() {
        this.user = this.storage.getItem(StorageKeys.CurrentUser, true) as UserDTO;

        this.suscribers.add(this.authSsgtService.userLoggedIn$.subscribe((data) => {
            this.user = data ?? ({} as UserDTO);
            this.refreshMenu();
        }));

        this.refreshMenu();
    }

    private refreshMenu(): void {
        const userRole = this.userRoleService.getRoleEnum();
        const menuModules = MenuConfig.getMenuModules(userRole);
        this.model = MenuConfig.buildMenuModel(menuModules, userRole);
    }

    

   
}
